import axios from "axios";
import { contractService } from "../../../../configs/constants";

// get booking detail service
export const generateSettlementReport = async (leaseId: string) => {
  const config: any = {
    method: "GET",
    url: `${contractService}/booking/generateSettlementReport/${leaseId}`,
  };

  try {
    const response = await axios(config);
    if (response.status === 200) return response.data;
  } catch (error) {
    return error.response;
  }
}

export const getMoveOutDetailService = async (leaseId: string, date) => {
  const config: any = {
    method: "GET",
    url: `${contractService}/booking/moveoutdetail/${leaseId}?moveOutDate=${date}`,
  };

  try {
    const response = await axios(config);


    if (response.status === 200) return response.data?.result;
  } catch (error) {
    return error.response;
  }
};

export const getApprovalPendingReq = async (approvaFor) => {
  const url = `${contractService}/booking?${approvaFor}`;
  try {
    const { data: { result } } = await axios.get(url);
    return result;
  } catch (error) {
    console.log(error);
  }
};